import React from 'react'

const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({ src, width, height }) => {
  return (
    <img
      src={src}
      width={width ? width : 'auto'}
      height={height ? height : 'auto'}
      style={{
        borderRadius: 10
      }}
    />
  )
}

export default Image